import { encode, decode } from "@msgpack/msgpack";
import { get, derived } from 'svelte/store';
import { user, api_init, version, auth, logout, token_refresh_is_due,
		 current_time, token_refresh_needed, encodedFileInfoFromFile } from './utils';

if (typeof env == 'undefined') {
	console.warn('window.env is not defined. env.MOD_API_URL and \
env.APP_ID_API_URL will be set to localhost:9080. rpc calls may not work');
	env = {};
}

env.MOD_API_URL = typeof env.MOD_API_URL == 'undefined' ?
												'http://localhost:8090/api' :
												env.MOD_API_URL;
env.APP_ID_API_URL = typeof env.APP_ID_API_URL == 'undefined' ?
												env.MOD_API_URL :
												env.APP_ID_API_URL;

const default_headers = {
	'Accept-Encoding': 'br',
	'Content-Type': 'application/msgpack',
};

let API = {
	logout,
	get is_token_expired() {
		return token_refresh_needed(Date.now() / 1000, get(auth))
	},
	async ApiRefresh(api_url) {
		const resp = await fetch(api_url, {
								method: 'POST',
								headers: default_headers,
								body: encode(['list'])
							});
		const data = await resp.arrayBuffer();
		try {
			const ddata = decode(data);
			version.set(ddata.version);
			for (let func of ddata.funcs) {
				const [mod, func_name] = func.split('.');
				if (!API[mod]) {
					API[mod] = {}
				}
				API[mod][func_name] = CallApi.bind(null, func, api_url);
			}
			return API;
		}
		catch (e) {
			console.log(e);
		}
	}
};

async function AllApiRefresh() {
	if (env.APP_ID_API_URL && env.MOD_API_URL !== env.APP_ID_API_URL) {
		await API.ApiRefresh(env.APP_ID_API_URL);
	}
	return await API.ApiRefresh(env.MOD_API_URL);
}

token_refresh_is_due.subscribe(val => {
	if (val && API.id.token_refresh)
		API.id.token_refresh()
});

function buildHeaders(tok) {
	if (tok) {
		return {...default_headers, Authorization: `Bearer ${tok}`};
	}
	return default_headers;
}

AllApiRefresh().then(function(_api) {
	api_init.set(true);
	if (API.id && API.id.user_me && get(auth).access_token)
		return API.id.user_me();
	else
		console.log('not logged in');
}).catch(function(err) {
	console.log(err, err.status);
});

async function CallApi(func_name, api_url, ...args) {

	// Convert file args to encoded info struct
	for (let i = 0; i < args.length; i++) {
		if (args[i] instanceof FileList) {
			args[i] = await Promise.all(Array.from(args[i]).map(async file => await encodedFileInfoFromFile(file)));
		}
		if (args[i] instanceof File) {
			args[i] = await encodedFileInfoFromFile(args[i]);
		}
	}
	// console.log(func_name, get(token_expires));
	if (API.is_token_expired && !['id.token_refresh', 'id.user_register', 'id.user_login', 'list'].includes(func_name)) {
		const ddata = await API.token_refresh();
		auth.merge(ddata);
	}

	const headers = func_name === 'id.token_refresh'
					? buildHeaders(get(auth).refresh_token)
					: buildHeaders(get(auth).access_token);
	let resp;
	try {
		resp = await fetch(api_url, {
			method: 'POST',
			headers,
			body: encode([func_name, ...args])
		});
		const data = await resp.arrayBuffer();
		const ddata = decode(data);
		// console.log(resp.status, data.byteLength, resp.headers);
		if (resp.status !== 200) {
			const {status} = resp;
			throw {status, ...ddata};
		}
		if (ddata.access_token && ddata.access_token_expires) {
			auth.merge(ddata);
		}
		if (ddata.refresh_token) {
			auth.merge(ddata);
		}
		if (ddata.user) {
			user.set(ddata.user);
		}
		return ddata;
	}
	catch (e) {
		if (e.autoaction) {
			const [mod, auto_func_name] = e.autoaction.split('.');
			const autoresp = await API[mod][auto_func_name]();
		}
		else
		{
			throw e;
		}
	}
}

export default API;
